<div class="table-wrapper pdb-30">
  @if (data && mitarbeiters) {
    <table class="striped">
      <thead>
        <tr>
          <td rowspan="2" class="no-border"></td>
          <th colspan="4" rowspan="2" class="header bold centered border-bold-left" scope="colgroup" translate>
          m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.table.colheader.ohneResiduen05</th>
          <th colspan="4" rowspan="2" class="header bold centered border-bold-left" scope="colgroup" translate>
          m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.table.colheader.ohneResiduen025</th>
          <th colspan="4" class="header bold centered border-bold-left" scope="colgroup" translate>
          m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.table.colheader.ohneResiduen5%</th>
          <th colspan="4" class="header bold centered border-bold-left border-bold-right" scope="colgroup" translate>
          m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.table.colheader.ohneResiduen10%</th>
        </tr>
        <tr>
          <td colspan="4" class="header centered border-bold-right border-bold-left" translate>
          m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.table.colheader.ohneResiduen5%.subtitle</td>
          <td colspan="4" class="header centered border-bold-left border-bold-right" translate>
          m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.table.colheader.ohneResiduen10%.subtitle</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="col" class="header bold centered border-bold-left border-bold-right" translate>
            m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.ausreisser-liste.table.colheader.grösste-kleinste-Ausreisser
          </th>
          @for (i of [].constructor(4); track i) {
            <th scope="col" class="centered"
              [innerHTML]="'m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.ausreisser-liste.table.rowheader.laufnummer' | translate">
            </th>
            <th scope="col" class="centered" translate>
            m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.ausreisser-liste.table.rowheader.geschlecht</th>
            <th scope="col" class="centered"
              [innerHTML]="'m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.ausreisser-liste.table.rowheader.gesamtverdienst' | translate">
            </th>
            <th scope="col" class="centered border-bold-right" translate>
            m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.ausreisser-liste.table.rowheader.residuum</th>
          }
        </tr>
        @for (n of [].constructor(25); track n; let i = $index) {
          <tr>
            <th scope="row" class="border-bold-left border-bold-right">{{i + 1}}</th>
            <td class="overflow text-align-right"
              [matTooltip]="data.ohneResiduen05[i]?.laufnummer | idToLnReturnLnAndFncname: mitarbeiters | async">
            {{data.ohneResiduen05[i]?.laufnummer | idToLaufnummer: mitarbeiters}}</td>
            <td class="text-align-left">{{data.ohneResiduen05[i]?.geschlecht}}</td>
            <td class="text-align-right">{{data.ohneResiduen05[i]?.gesamtverdienst | numberFormat: crtLocale}}</td>
            <td class="border-bold-right text-align-right">{{data.ohneResiduen05[i]?.residuum | numberFormat: crtLocale:3}}</td>
            <td class="overflow text-align-right"
              [matTooltip]="data.ohneResiduen025[i]?.laufnummer | idToLnReturnLnAndFncname: mitarbeiters | async">
            {{data.ohneResiduen025[i]?.laufnummer | idToLaufnummer: mitarbeiters}}</td>
            <td class="text-align-left">{{data.ohneResiduen025[i]?.geschlecht}}</td>
            <td class="text-align-right">{{data.ohneResiduen025[i]?.gesamtverdienst | numberFormat: crtLocale}}</td>
            <td class="border-bold-right text-align-right">{{data.ohneResiduen025[i]?.residuum | numberFormat: crtLocale:3}}</td>
            <td class="overflow text-align-right"
              [matTooltip]="data.ohneResiduen5Prozent[i]?.laufnummer | idToLnReturnLnAndFncname: mitarbeiters | async">
            {{data.ohneResiduen5Prozent[i]?.laufnummer | idToLaufnummer: mitarbeiters}}</td>
            <td class="text-align-left">{{data.ohneResiduen5Prozent[i]?.geschlecht}}</td>
            <td class="text-align-right">{{data.ohneResiduen5Prozent[i]?.gesamtverdienst | numberFormat: crtLocale}}</td>
            <td class="border-bold-right text-align-right">{{data.ohneResiduen5Prozent[i]?.residuum | numberFormat: crtLocale:3}}</td>
            <td class="overflow text-align-right"
              [matTooltip]="data.ohneResiduen10Prozent[i]?.laufnummer | idToLnReturnLnAndFncname: mitarbeiters | async">
            {{data.ohneResiduen10Prozent[i]?.laufnummer | idToLaufnummer: mitarbeiters}}</td>
            <td class="text-align-left">{{data.ohneResiduen10Prozent[i]?.geschlecht}}</td>
            <td class="text-align-right">{{data.ohneResiduen10Prozent[i]?.gesamtverdienst | numberFormat: crtLocale}}</td>
            <td class="border-bold-right text-align-right">{{data.ohneResiduen10Prozent[i]?.residuum | numberFormat: crtLocale:3}}</td>
          </tr>
        }
      </tbody>
      <tfoot>
        <tr>
          <td colspan="17" class="hint" translate>
          m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.ausreisser-liste.footer-hint</td>
        </tr>
      </tfoot>
    </table>
  }
</div>
